import React, { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Container, Col } from 'reactstrap';
import AppHeader from '../Common/AppHeader';
import NavMenu from './NavMenu';

export default function Layout({ onNavigationClick, selectedMenu, navigationItems, children }) {
    const params = useParams()
    const [navMenuClicked, setNavMenuClicked] = useState(false);
    const [navMenuItemClicked, setNavMenuItemClicked] = useState(false);
    useEffect(() => handleAddResizeEvent(), []);

    function handleAddResizeEvent() {
        function handleResize() {
            if (window.innerWidth <= 925) {
                setNavMenuClicked(false);
                setNavMenuItemClicked(false);
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }

    function handleHamburgerClick() {
        setNavMenuItemClicked(false);
        setNavMenuClicked(!navMenuClicked);
    }

    function handleNavigationClick(name) {
        onNavigationClick(name);
        setNavMenuItemClicked(true);
        setNavMenuClicked(false);
    }

    var showNav = params.accessToken64 === undefined;
    var navMenu = showNav && (
        <div className="navigation-menu-container">
            <NavMenu
                onNavigationClick={handleNavigationClick}
                selectedMenu={selectedMenu}
                navigationItems={navigationItems}
                onHamburgerClick={handleHamburgerClick}
            />
        </div>);

    let navMenuClickedClass = navMenuClicked ? " navMenuClicked" : "";
    let navMenuItemClickedClass = navMenuItemClicked ? " navMenuItemClicked" : "";
    
    return (
        <div className={`main-pane-container${navMenuClickedClass} ${navMenuItemClickedClass}`}>
            {navMenu}
            <div className="main-pane">
                <AppHeader appName="Docshare" onHamburgerClick={handleHamburgerClick} showAuthentication={false} />
                <Col className="py-2 px-2 background-white">
                    {children}
                </Col>
            </div>
        </div>
    );
}